export default __webpack_public_path__ + "fabdd30cf4b3c080c1ad5e551be60770.svg";